import { DefaultValues, useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { IShipmentStopAppointmentTypes, IShipmentStopTypes } from 'types/graphqlTypes'
import { CreateShipmentSchema, TCreateShipmentSchema } from '../schema'
import { IUseCreateShipmentFormContext } from '../types'

export const getDefaultValues = <TFieldValues>(values: DefaultValues<TFieldValues>) => {
  return CreateShipmentSchema.cast({
    shipment: {
      stops: [
        {
          appointmentType: IShipmentStopAppointmentTypes.appointment,
          stopSequence: 1,
          stopType: IShipmentStopTypes.pickup,
          startAtDate: null,
        },
        {
          appointmentType: IShipmentStopAppointmentTypes.appointment,
          stopSequence: 1,
          stopType: IShipmentStopTypes.delivery,
          startAtDate: null,
        },
      ],
    },
    ...values,
  })
}

export interface IUseCreateShipmentFormProps
  extends Omit<UseFormOptions<TCreateShipmentSchema, IUseCreateShipmentFormContext>, 'resolver'> {}

export const useCreateShipmentForm = ({
  defaultValues = {},
  context,
  ...props
}: IUseCreateShipmentFormProps = {}) => {
  return useForm<TCreateShipmentSchema, IUseCreateShipmentFormContext>({
    context,
    mode: 'onTouched',
    resolver: yupResolver(CreateShipmentSchema),
    defaultValues: getDefaultValues(defaultValues),
    ...props,
  })
}
